import React, { Component } from 'react';
import SideNav from '../components/SideNav/SideNav';
import Header from '../components/Header/Header';

class Wrapper extends Component {
  render() {
    return (
      <div>
        <Header />
        <SideNav title="Pricing Data Application"/>
        <div className="pda-wrapper">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Wrapper;
